/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxGamesLibWebPublicDataBaseTurnstileOptions } from './FxGamesLibWebPublicDataBaseTurnstileOptions';
import {
    instanceOfFxGamesLibWebPublicDataBaseTurnstileOptions,
    FxGamesLibWebPublicDataBaseTurnstileOptionsFromJSON,
    FxGamesLibWebPublicDataBaseTurnstileOptionsFromJSONTyped,
    FxGamesLibWebPublicDataBaseTurnstileOptionsToJSON,
} from './FxGamesLibWebPublicDataBaseTurnstileOptions';

/**
 * @type FxGamesLibWebPublicDataBaseTurnstile
 * Настройки для Cloudflare Turnstile
 * @export
 */
export type FxGamesLibWebPublicDataBaseTurnstile = FxGamesLibWebPublicDataBaseTurnstileOptions;

export function FxGamesLibWebPublicDataBaseTurnstileFromJSON(json: any): FxGamesLibWebPublicDataBaseTurnstile {
    return FxGamesLibWebPublicDataBaseTurnstileFromJSONTyped(json, false);
}

export function FxGamesLibWebPublicDataBaseTurnstileFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPublicDataBaseTurnstile {
    if (json == null) {
        return json;
    }
    if (instanceOfFxGamesLibWebPublicDataBaseTurnstileOptions(json)) {
        return FxGamesLibWebPublicDataBaseTurnstileOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxGamesLibWebPublicDataBaseTurnstileToJSON(json: any): any {
    return FxGamesLibWebPublicDataBaseTurnstileToJSONTyped(json, false);
}

export function FxGamesLibWebPublicDataBaseTurnstileToJSONTyped(value?: FxGamesLibWebPublicDataBaseTurnstile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxGamesLibWebPublicDataBaseTurnstileOptions(value)) {
        return FxGamesLibWebPublicDataBaseTurnstileOptionsToJSON(value as FxGamesLibWebPublicDataBaseTurnstileOptions);
    }

    return {};
}

